import React from 'react'
import { Box, InputBase } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { C, FONT_BODY, RADIUS } from '../../utils/designTokens'

const HeaderSearchBar = ({ value, onChange, placeholder, onFocus, onBlur, onKeyDown, ariaLabel }) => {
  return (
    <Box
      component="label"
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: 44,
        boxSizing: 'border-box',
        backgroundColor: C.surface2,
        border: '1px solid transparent',
        borderRadius: RADIUS.pill,
        padding: '0 16px',
        flex: 1,
        minWidth: 0,
        maxWidth: '100%',
        cursor: 'text',
        transition: 'background-color .15s ease, border-color .15s ease',
        '&:hover': { backgroundColor: C.border },
        '&:focus-within': {
          backgroundColor: C.bg,
          borderColor: C.ink,
        },
      }}
    >
      <SearchIcon sx={{ color: C.muted, fontSize: 20, mr: 1, flexShrink: 0 }} />
      <InputBase
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        placeholder={placeholder || "Search restaurants and dishes"}
        inputProps={{ 'aria-label': ariaLabel || placeholder || 'Search restaurants and dishes' }}
        sx={{
          flex: 1,
          fontFamily: FONT_BODY,
          color: C.ink,
          // iOS Safari auto-zooms into any input whose font-size is < 16px.
          // Use 14px on desktop but bump to 16px on phones so focus doesn't
          // trigger a viewport zoom-in.
          fontSize: { xs: '16px', md: '0.875rem' },
          minWidth: 0,
          '& input': {
            padding: 0,
            // Ensure the inner <input> inherits the same size — InputBase
            // sometimes resets it back to 1rem in Safari.
            fontSize: 'inherit',
            '&::placeholder': {
              color: C.muted,
              opacity: 1,
            },
          },
        }}
      />
    </Box>
  )
}

export default HeaderSearchBar
